import MembershipProfileTag from '@components/membership/membership-profile-tag/MembershipProfileTag'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { MembershipProfileTag as MembershipProfileTagModel } from '@models/membership/MembershipProfileTag'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getMembershipProfileTags,
  selectMembershipProfileTags,
  setMembershipProfileTagQuery,
} from '@store/membership/MembershipProfileTagReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { Space } from 'antd'
import { useEffect } from 'react'

const MembershipProfileTagsPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const membershipProfileTags = useAppSelector(selectMembershipProfileTags())
  const { query, isLoading } = useAppSelector(
    (state) => state.membershipProfileTag
  )

  const columns: TableColumnsType<MembershipProfileTagModel> = [
    {
      title: 'Tag',
      render: (record: MembershipProfileTagModel) => (
        <MembershipProfileTag.Tag id={record.id} />
      ),
    },
    {
      align: 'right',
      render: (record: MembershipProfileTagModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.membershipProfileTag}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchMembershipProfileTags = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setMembershipProfileTagQuery(newQuery))
    dispatch(getMembershipProfileTags(newQuery))
  }

  const { handleTableChange, params } =
    useTableUrlSync<MembershipProfileTagModel>({
      onParamsChange: fetchMembershipProfileTags,
    })

  useEffect(() => {
    if (isOpen) return

    fetchMembershipProfileTags(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.manageRequestsMembership}
      pageTitle={{
        title: 'Membership profile tags',
        level: 4,
        toolbar: (
          <Space>
            <SBRM.Actions
              actions={[SBRMAction.Create]}
              entity={Entity.membershipProfileTag}
            />
          </Space>
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={membershipProfileTags}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        showSorterTooltip={{ target: 'sorter-icon' }}
      />
    </Page>
  )
}

export default MembershipProfileTagsPage
